import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./index.css";
import "./App.css";
import App, { preloadRoute } from "./App";
import { reportWebVitals } from "./reportWebVitals";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById("root");
// hydrateRoot для pre-rendered HTML (react-snap), createRoot для обычного запуска.
const app = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
if (rootEl.hasChildNodes()) {
  // Ждём чанк текущего маршрута и только потом гидратируем.
  //
  // Все страницы объявлены через React.lazy. Если начать гидратацию до
  // загрузки чанка, React упирается в неразрешённый lazy, suspend'ится и
  // заменяет ВЕСЬ pre-rendered HTML на <PageLoader/>. Замер на проде
  // (Chrome 151, 4x CPU, slow 4G): контент был отрисован на 1.5с, в 3.5с
  // подменён спиннером и вернулся лишь в 6.1с — LCP фиксировался на 6.1с
  // при FCP 3.3с. Предзагрузка убирает подмену: статика остаётся на экране,
  // гидратация происходит поверх неё.
  preloadRoute(window.location.pathname).then(() => {
    ReactDOM.hydrateRoot(rootEl, app);
  });
} else {
  ReactDOM.createRoot(rootEl).render(app);
}

// Core Web Vitals → Яндекс.Метрика (только реальные пользователи, не prerender)
if (typeof window !== "undefined" && navigator.userAgent !== "ReactSnap") {
  reportWebVitals();
}
